import FloatOnScroll from '../float_on_scroll/float_on_scroll'
import 'sticky-sidebar/dist/sticky-sidebar';

const clientsFilter = {
    addHandlerResetForm () {
        $('.js--clients_filter_reset').click((event) => {
            const $form = $(event.currentTarget).closest('form')
            $form.find('[type="radio"]').prop('checked', false)
            $form.submit()
        })
    },
    addHandlerChangeForm () {
        const $form = $('.js--clients_filter')
        $form.change(() => {
            $form.submit();
        });
        const $select = $('.js--filter_select');
        $select.change((event) => {
            const $element = $(event.currentTarget)
            const name = $element.data('name');
            const value = $element.val();
            $form.find(`input[name="${name}"][value="${value}"]`).prop('checked', true);
        });
    },
    initStickySidebar() {
        const stikySidebar = new StickySidebar('.sidebar', {
            topSpacing: 0,
            bottomSpacing: 20,
            containerSelector: '.js--examples',
            innerWrapperSelector: '.sidebar__inner',
        });
    },
    initFloatFilter() {
        const filterFloat = new FloatOnScroll();
        filterFloat.initFloat();
    },
    init() {
        this.addHandlerResetForm();
        this.addHandlerChangeForm();
        this.initFloatFilter();
    }
}

export default clientsFilter



// WEBPACK FOOTER //
// ./private/blocks/clients_filter/clients_filter.js